// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/Users/nlwy/Documents/workspace/web-scoutech/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import AppstoreOutlined from '/Users/nlwy/Documents/workspace/web-scoutech/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/AppstoreOutlined';
import TeamOutlined from '/Users/nlwy/Documents/workspace/web-scoutech/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/TeamOutlined';
export default { SmileOutlined, AppstoreOutlined, TeamOutlined };
